var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prog_Views_Icon",
    "data-name": "Prog Views Icon",
    transform: "translate(4072 -4498)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(-4072 4530) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "visibility_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M52-786.909a4.734,4.734,0,0,0,3.477-1.432,4.734,4.734,0,0,0,1.432-3.477,4.734,4.734,0,0,0-1.432-3.477A4.734,4.734,0,0,0,52-796.727a4.734,4.734,0,0,0-3.477,1.432,4.734,4.734,0,0,0-1.432,3.477,4.734,4.734,0,0,0,1.432,3.477A4.734,4.734,0,0,0,52-786.909Zm0-1.964a2.841,2.841,0,0,1-2.086-.859,2.841,2.841,0,0,1-.859-2.086,2.84,2.84,0,0,1,.859-2.086A2.84,2.84,0,0,1,52-794.764a2.84,2.84,0,0,1,2.086.859,2.84,2.84,0,0,1,.859,2.086,2.841,2.841,0,0,1-.859,2.086A2.841,2.841,0,0,1,52-788.873Zm0,5.236a12.63,12.63,0,0,1-7.255-2.223A12.635,12.635,0,0,1,40-791.818a12.635,12.635,0,0,1,4.745-5.959A12.63,12.63,0,0,1,52-800a12.63,12.63,0,0,1,7.255,2.223A12.635,12.635,0,0,1,64-791.818a12.635,12.635,0,0,1-4.745,5.959A12.63,12.63,0,0,1,52-783.636Z",
    transform: "translate(-4108 5306)",
    fill: "#0469ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalReport);
export default __webpack_public_path__ + "static/media/finalReport.0c0895dcb13a2782594eff86aa5e8c41.svg";
export { ForwardRef as ReactComponent };